import { CustomImage } from '../../../../functions/Image';
import React from 'react';
import { getWarrantyMobileModelsDisplay } from '../../../report-warranty/columns';

export const ExpandedRowContent = ({ record }) => {
  const productName = record?.productName ?? '';
  const modelsLine = getWarrantyMobileModelsDisplay(record);

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-start', gap: 10 }}>
      <CustomImage width={80} preview src={record?.claimImageUrl} style={{ borderRadius: 10 }} />
      <CustomImage width={80} preview src={record?.receiptImageUrl} style={{ borderRadius: 10 }} />
      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '20px' }}>
        <div style={{ marginBottom: '8px' }}>
          <strong>ชื่อสินค้า: </strong>
          {productName}
        </div>
        <div style={{ marginBottom: '8px' }}>
          <strong>รุ่น: </strong>
          {modelsLine}
        </div>
        <div>
          <strong>อาการเสีย: </strong>
          {record.breakdownName}
        </div>
      </div>
    </div>
  );
};
